/**
 * Rozdeleni vysky sloupce JEDU v presetu vyjezd-2026 mezi Jedou a skupinu „V zaloze“
 * (UX F1): nejdriv nadpis a zaloha (nejvyse 4 radky), zbytek dostanou Jedou. Konstanty
 * odpovidaji skutecnemu kroku radku vcetne dolniho okraje mb 0.5 (4 px): kompakt 36 + 4 = 40 px,
 * velky 54 + 4 = 58 px (1.3rem / 1.85rem * line-height 1.5 + padding 2 * 2.4 px).
 */
export const RADEK_KOMPAKT = 40;
export const RADEK_VELKY = 58;
/** Nadpis „V ZALOZE ─ N“ (1.1rem * 1.2) + mb 4 px + mt 8 px skupiny. */
export const ZALOHA_HLAVICKA = 33;
/** Radek „+ X dalsich v zaloze“ (1rem, line-height 1.5). */
export const ZALOHA_PLUS = 24;
const PADDING = 8;
export const MAX_ZALOHA = 4;
const MAX_ZALOHA_ZUZENO = 3;
/** Kolik Jedou ma zbyt, aby se zaloha nemusela zkracovat (UX F1). */
const MIN_JEDOU = 6;
/** Pod timto poctem by sloupec nedaval smysl; kdyz se i tak nevejde, rozhodne ořez, ne vynucovani. */
const MIN_RADKU = 2;
/** Dokud se kontejner nezmeril (vyska 0), nic neorezavame. */
const NEZMERENO = 20;

export interface RozlozeniVstup {
    /** clientHeight kontejneru odpovedi; 0 = jeste nezmereno. */
    vyska: number;
    pocetJedou: number;
    pocetZaloha: number;
    /** Velke radky Jedou (jen kdyz Jedou + zaloha <= 6). */
    velkeJedou: boolean;
}

export interface Rozlozeni {
    /** Max. radku sloupce Jedou vcetne mista pro „+ X dalsich“ (pouziti: slice(0, max - 1)). */
    maxJedou: number;
    /** Hodnota `maxViditelnych` pro ZalohaSkupina. */
    maxZaloha: number;
}

export const zalohaVyska = (pocet: number, maxViditelnych: number): number => {
    if (pocet <= 0) return 0;
    const preteka = pocet > maxViditelnych;
    const viditelne = preteka ? Math.max(maxViditelnych - 1, 0) : pocet;
    return ZALOHA_HLAVICKA + viditelne * RADEK_KOMPAKT + (preteka ? ZALOHA_PLUS : 0);
};

/**
 * Zaloha nesmi vytlacit Jedou: kdyby se jich pri plne zaloze veslo mene nez 6 (nebo mene, nez
 * kolik jich je), zaloha se zkrati na dve jmena a „+X“. `kolikJedou(maxZaloha)` vraci, kolik
 * Jedou se vejde vedle zalohy s danym limitem.
 */
export const zvolMaxZaloha = (
    pocetZaloha: number, pocetJedou: number, kolikJedou: (maxZaloha: number) => number,
): number =>
    pocetZaloha >= MAX_ZALOHA_ZUZENO && kolikJedou(MAX_ZALOHA) < Math.min(pocetJedou, MIN_JEDOU)
        ? MAX_ZALOHA_ZUZENO
        : MAX_ZALOHA;

export const spocitejRozlozeni = ({ vyska, pocetJedou, pocetZaloha, velkeJedou }: RozlozeniVstup): Rozlozeni => {
    if (vyska <= 0) return { maxJedou: NEZMERENO, maxZaloha: MAX_ZALOHA };
    const dostupne = vyska - PADDING;
    const vyskaRadkuJedou = velkeJedou ? RADEK_VELKY : RADEK_KOMPAKT;
    const radkuJedou = (maxZaloha: number) =>
        Math.floor((dostupne - zalohaVyska(pocetZaloha, maxZaloha)) / vyskaRadkuJedou);

    const maxZaloha = zvolMaxZaloha(pocetZaloha, pocetJedou, radkuJedou);
    return { maxJedou: Math.max(MIN_RADKU, radkuJedou(maxZaloha)), maxZaloha };
};

/** Pocet radku sloupce NEJEDU (vzdy kompaktni). */
export const maxNejedou = (vyska: number): number =>
    vyska <= 0 ? NEZMERENO : Math.max(MIN_RADKU, Math.floor((vyska - PADDING) / RADEK_KOMPAKT));
